import { bindPages, show } from '@makan/command-center/kit';
import type { SwitchRow } from '../domain/index.ts';
import { DEFAULT_TOOLKIT_MODE, routes, toolkitShows } from '../domain/values.ts';
import { t } from './strings.ts';

/**
 * The ui surface entry: the inbox page, its place in the sidebar (managers),
 * and the toolkit layer over every page. The layer's gate reads the switch
 * row and decides with `toolkitShows`; only a yes imports toolkit.tsx, so
 * nobody else downloads the toolkit's code.
 */
export const ui = bindPages(
  routes,
  {
    inbox: () => import('./inbox.tsx'),
  },
  {
    inbox: { label: t.inbox.title, icon: 'megaphone', rank: 90, shows: (staff) => staff.role === 'manager' },
  },
  {
    shows: async (staff) => {
      const answer = await show(staff.groupId, 'feedback', 'feedback-switch');
      const row = answer.outcome === 'rows' ? (answer.rows[0] as SwitchRow | undefined) : undefined;
      return toolkitShows({ environment: staff.environment, mode: row?.mode ?? DEFAULT_TOOLKIT_MODE, testers: row?.testers ?? [], staffId: staff.staffId });
    },
    load: () => import('./toolkit.tsx'),
  },
);
